import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';
import { DepositComponent } from '../deposit/deposit.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-deposit-list',
  templateUrl: './deposit-list.component.html',
  styleUrls: ['./deposit-list.component.css']
})
export class DepositListComponent implements OnInit {

  public menu_item_id = '23';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];

  displayedColumns = ['deposit_no', 'cash_account', 'account_name', 'deposit_amount', 'deposit_date',
    'attach', 'edit', 'del'];
  displayedColumns2 = ['deposit_no', 'cash_account', 'account_name', 'deposit_amount', 'deposit_date'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<DepositComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'deposit', 'from_date': new Date(), 'to_date': new Date(),
    'deposit_no': '', 'branch_id': '0', 'title': 'الإيداعات'
  };

  branchList = [];

  Success_Msg; Error_Msg; Del_Msg; From_Date; To_Date; Deposit_List;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Deposit_List').subscribe((res: string) => {
      this.Deposit_List = res;
    });
    this.model['title'] = this.Deposit_List;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {

    let condition = "";
    if (this.model['from_date'] != undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + " 00:00:00";
      condition += " AND `deposit`.`deposit_date` >= '" + from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + " 23:59:59";
      condition += " AND `deposit`.`deposit_date` <= '" + to_date + "'";
    }

    if (this.model['deposit_no'] != '')
      condition = " AND `deposit`.`deposit_no` LIKE '%" + this.model['deposit_no'] + "%'";

    if (this.model['branch_id'] != '0')
      condition += " AND `deposit`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '0') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `deposit`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '0') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    let query = "SELECT `deposit`.*," +
      " (CASE WHEN `from_acct` != '' THEN (SELECT `sub_acct`.`sub_acct_name` FROM `sub_acct` WHERE " +
      "`sub_acct`.`acct_number` = `deposit`.`from_acct`) ELSE '' END) AS `cash_account`," +
      " (CASE WHEN `from_acct` != '' THEN (SELECT `sub_acct`.`sub_acct_name_en` FROM `sub_acct` WHERE " +
      "`sub_acct`.`acct_number` = `deposit`.`from_acct`) ELSE '' END) AS `cash_account_en`," +
      " (CASE WHEN `to_acct` != '' THEN (SELECT `sub_acct`.`sub_acct_name` FROM `sub_acct` WHERE " +
      "`sub_acct`.`acct_number` = `deposit`.`to_acct`) ELSE '' END) AS `account_name`," +
      " (CASE WHEN `to_acct` != '' THEN (SELECT `sub_acct`.`sub_acct_name_en` FROM `sub_acct` WHERE " +
      "`sub_acct`.`acct_number` = `deposit`.`to_acct`) ELSE '' END) AS `account_name_en`" +
      " FROM `deposit` WHERE `deposit`.`status` != '0' " + condition + " ORDER BY `deposit`.`deposit_no`";

    // console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dp.forEach(element => {
          element.cash_account = element.from_acct + " - " + element.cash_account + " - " + element.cash_account_en;
          element.account_name = element.to_acct + " - " + element.account_name + " - " + element.account_name_en;
          element.date = element.deposit_date;
          element.deposit_date = (element.deposit_date).substring(0, 10);
        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newDeposit() {
    this.addDialogRef = this.dialog.open(DepositComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editDeposit(row) {
    let dialog_data = {
      'table_name': 'deposit', 'deposit_id': row.deposit_id,
      'deposit_no': row.deposit_no,
      'no': row.no,
      'year': row.year,
      'from_acct': row.from_acct,
      'deposit_amount': row.deposit_amount,
      'flag': 'update',
      'key': 'deposit_id',
      'to_acct': row.to_acct,
      'deposit_date': row.date,
      'deposit_attach': row.deposit_attach,
      'comment': row.comment,
      'branch_id': row.branch_id
    };
    this.addDialogRef = this.dialog.open(DepositComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delDeposit(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'deposit_no': row.deposit_no }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="50%"> ' + this.From_Date + ': ' + this.model['from_date'].getFullYear() + "-" +
      (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + '</td>';
    html_data += '<td width="50%"> ' + this.To_Date + ': ' + this.model['to_date'].getFullYear() + "-" +
      (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate() + ' </td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('deposit_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
